import { Center, FormControl, Text, forwardRef } from '@chakra-ui/react';
import * as React from 'react';

import { DragAndDropImageUpload } from '@/components/DragAndDropImageUpload';
import { EPrepImagesSource } from '@/graphql-types/globalTypes';

export const GroupBannerImagePicker = forwardRef<
  {
    value?: string;
    onChange: (value: string) => void;
    nonDraftImageProxy: string | null;
  },
  'div'
>((props, ref) => {
  return (
    <FormControl ref={ref}>
      <DragAndDropImageUpload
        value={props.value}
        onChange={props.onChange}
        aria-label="Group banner image"
        source={EPrepImagesSource.DEFAULT}
        imageInput={{ ar: '8:3', w: 1600, fit: 'fill', fill: 'blur' }}
        imageProps={{ borderRadius: 'xl' }}
        nonDraftImageProxy={props.nonDraftImageProxy}
      />
      <Center w="full" mt="6">
        <Text color={'gray.500'}>The image size is 1600px by 600px</Text>
      </Center>
    </FormControl>
  );
});
